class CalendarMonth extends React.Component {

    constructor(props) {
        super(props);

        this.selectDate = this.selectDate.bind(this);
    }

    selectDate(date) {
        var today = this.props.today;

        if (moment(date).isBefore(today) && !this.props.allowPastDate)
            return;

        this.props.selectDate(date);
    }

    render() {
        var self = this;
        var today = this.props.today;
        var selected = this.props.selected;

        var arrDay = this.props.data ? this.props.data : [];
        var arrDayShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        var buffer = [];
        var calendar = [];

        var i = 0;
        while (arrDayShort[i] !== arrDay[0].ddd) {
            buffer.push(<div className='cal-month__day' key={'buffer_'+i}>&nbsp;</div>);
            i++;
        }

        return (
            <div className={'cal-month '+this.props.className}>

                { arrDayShort.map((day, i) =>
                    <div
                        className='cal-month__ddd'
                        key={'ddd_'+i}>

                        {day}
                    </div>
                )}

                <div className='clear' />

                { buffer }

                { arrDay.map(function(d, i) {

                    if (!d.date)
                        return (
                            <div 
                                className='clear'
                                key={uuid()} />
                        );

                    var cssToday = today === d.date ? 'cal-month__today' : '';
                    var cssBeforeToday = moment(d.date).isBefore(today) ? '':'';//cal-month__before-today' : '';
                    var cssSelectedDate = selected === d.date ? 'cal-month__selected' : '';
                    var cssCursor = moment(d.date).isBefore(today) && self.props.allowPastDate ? 'url-cursor' : '';

                    var alt = today === d.date ? 'Today' : '';

                    return (
                        <div
                            className={'cal-month__day '+cssToday+' '+cssBeforeToday+' '+cssSelectedDate+' '+cssCursor}
                            onClick={self.selectDate.bind(self, d.date)}
                            title={alt}
                            key={uuid()}>

                            {moment(d.date).format('D')}
                        </div>
                    );
                })}

            </div>
        );
    }
}

export default CalendarMonth;


                // { arrDay.map(function(day, i) {

                //     return (
                //         <div
                //             className='cal-month__day'
                //             key={'day_'+i}>

                //             {day.date}
                //         </div>
                //     );
                // })}


// WEBPACK FOOTER //
// ./ui_src/app/components/form/CalendarMonth.react.jsx